import styles from "../../../styles/CoordinationBoards.module.css"
import { useContext, useState } from "react"
import { UserContext } from "../../../context/userContext"
import axios from "axios"
import { coordinationBoardsApiUrl } from "../../../config/microservicesUrls"
import { BoardType } from "../Types/Enums"
import { Dialog } from "primereact/dialog"
import { Dropdown } from 'primereact/dropdown'
import { Checkbox } from "primereact/checkbox"
import { Button } from "primereact/button"
import { requiredFieldIsMissing, showError, renderRequireFieldErrorMessage } from "../Utils/Utils"

const api_url = coordinationBoardsApiUrl()

const CrossOrganizationBoardForm = ({ dialogVisible, setDialogVisible, organizations, addBoard, toast }) => {
    const userCtx = useContext(UserContext)

    const defaultCrossOrgBoardData = {
        type: BoardType["Cross Organization"],
        createdBy: userCtx.session.user.staff_id,
        ownerEnterpriseId: userCtx.session.user.enterprise_id,
        ownerOrganizationId: userCtx.session.user.organization_id,
        organization1: null,
        organization2: null,
        enabled: true,
        readOnly: false
    }

    const [crossOrgBoardData, setCrossOrgBoard] = useState(defaultCrossOrgBoardData)
    const [loadingNewCrossOrgBoard, setLoadingNewCrossOrgBoard] = useState(false)
    const [showErrors, setShowErrors] = useState(false)

    const clearForm = () => {
        setCrossOrgBoard(defaultCrossOrgBoardData)
        setShowErrors(false)
        setLoadingNewCrossOrgBoard(false)
    }

    const saveCrossOrgBoard = () => {
        //if organization1 or organization2 is null, show error
        if (requiredFieldIsMissing(crossOrgBoardData.organization1)
            || requiredFieldIsMissing(crossOrgBoardData.organization2)) {
            setShowErrors(true)
            return
        }

        const data = {
            ...crossOrgBoardData,
            organizationIds: [crossOrgBoardData.organization1, crossOrgBoardData.organization2]
        }

        setLoadingNewCrossOrgBoard(true)

        axios
            .post(`${api_url}/boards`,
                data,
                {
                    headers: { Authorization: `Bearer ${userCtx.tokenCoordinationBoards}` },
                })
            .then(function (response) {
                setLoadingNewCrossOrgBoard(false)
                addBoard(response.data)
                clearForm()
                setDialogVisible(false)
            })
            .catch(function (response) {
                setLoadingNewCrossOrgBoard(false)
                const errors = response["response"]["data"]["errors"]
                showError(toast, errors, errors)
            })
    }


    return (
        <Dialog
            header="New Cross Organization Board"
            className={`custom_dialog ${styles.cross_org_dialog}`}
            visible={dialogVisible}
            onHide={() => {
                clearForm()
                setDialogVisible(false)
            }}
        >
            <div
                style={{
                    padding: "10px",
                }}
            >
                <div className={styles.field}>
                    <label className={styles.label}>Organization #1</label>
                    <div>
                        <Dropdown
                            value={crossOrgBoardData.organization1}
                            filter
                            options={organizations.filter((org) => crossOrgBoardData.organization2 != null ? org.id !== crossOrgBoardData.organization2 : true)}
                            panelClassName="custom_dropdown_panel"
                            onChange={(e) =>
                                setCrossOrgBoard({ ...crossOrgBoardData, organization1: e.value })
                            }
                            optionLabel="name"
                            optionValue="id"
                            placeholder="Select an organization"
                            style={{ width: "100%" }}
                            className={`${styles.selector} ${showErrors && requiredFieldIsMissing(crossOrgBoardData.organization1) ? styles.invalid : ''}`}
                        />
                        {showErrors && renderRequireFieldErrorMessage(
                            crossOrgBoardData.organization1,
                            "Organization #1 is required"
                        )}
                    </div>
                </div>
                <div className={styles.field}>
                    <label className={styles.label}>Organization #2</label>
                    <div>
                        <Dropdown
                            value={crossOrgBoardData.organization2}
                            filter
                            options={organizations.filter((org) => crossOrgBoardData.organization1 != null ? org.id !== crossOrgBoardData.organization1 : true)}
                            panelClassName="custom_dropdown_panel"
                            optionLabel="name"
                            optionValue="id"
                            onChange={(e) =>
                                setCrossOrgBoard({ ...crossOrgBoardData, organization2: e.value })
                            }
                            placeholder="Select an organization"
                            style={{ width: "100%" }}
                            className={`{${styles.selector} ${showErrors && requiredFieldIsMissing(crossOrgBoardData.organization2) ? styles.invalid : ""}}`}
                        />
                        {showErrors && renderRequireFieldErrorMessage(
                            crossOrgBoardData.organization2,
                            "Organization #2 is required"
                        )}
                    </div>
                </div>
                <div className={styles.field}
                    style={{
                        display: "flex",
                        gap: "20px",
                        justifyContent: "flex-start",
                    }}
                >
                    <div className={styles.chkbox}>
                        <Checkbox
                            inputId="new_crossOrgBoard_enabled"
                            name="category"
                            className={`${styles.checkbox_design} ${styles.checkbox_border}`}
                            value={crossOrgBoardData.enabled}
                            onChange={(e) => {
                                setCrossOrgBoard({ ...crossOrgBoardData, enabled: e.checked })
                            }}
                            checked={crossOrgBoardData.enabled}
                        />
                        <label htmlFor="new_crossOrgBoard_enabled" style={{ marginLeft: "7px" }}>
                            Enabled
                        </label>
                    </div>
                    <div className={styles.chkbox}>
                        <Checkbox
                            inputId="new_crossOrgBoard_readonly"
                            name="category"
                            className={`${styles.checkbox_design} ${styles.checkbox_border}`}
                            value={crossOrgBoardData.readOnly}
                            onChange={(e) => {
                                setCrossOrgBoard({ ...crossOrgBoardData, readOnly: e.checked })
                            }}
                            checked={crossOrgBoardData.readOnly}
                        />
                        <label htmlFor="new_crossOrgBoard_readonly" style={{ marginLeft: "7px" }}>
                            Read-only
                        </label>
                    </div>
                </div>
                <div
                    style={{
                        display: "flex",
                        gap: "20px",
                        justifyContent: "flex-end",
                    }}
                >
                    <Button
                        className={styles.cancel_button}
                        type="submit"
                        disabled={loadingNewCrossOrgBoard}
                        onClick={() => {
                            clearForm()
                            setDialogVisible(false)
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        className={styles.button}
                        type="submit"
                        style={{
                            width: "91px!important",
                            justifyContent: "center",
                        }}
                        disabled={loadingNewCrossOrgBoard}
                        onClick={() => saveCrossOrgBoard()}
                    >
                        Create board
                    </Button>
                </div>
            </div>
        </Dialog>
    )
}
export default CrossOrganizationBoardForm
